"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyVfxEffectHandler = exports.ApplyVfxEffectArgs = void 0;
const Registries_1 = require("../../state/Registries");
const Parallel_1 = require("../../vfx/core/Parallel");
const Sequential_1 = require("../../vfx/core/Sequential");
const EffectType_1 = require("../EffectType");
class ApplyVfxEffectArgs {
    constructor(vfx) {
        this.vfx = vfx;
        this.__type = EffectType_1.EffectType.ApplyVfx;
        this.__typeName = "ApplyVfx";
        this.name = "Visual Effect";
        this.harmful = false;
    }
}
exports.ApplyVfxEffectArgs = ApplyVfxEffectArgs;
ApplyVfxEffectArgs.Parallel = (vfx) => new ApplyVfxEffectArgs(new Parallel_1.ParallelVfxStepArgs(vfx));
ApplyVfxEffectArgs.Sequential = (vfx) => new ApplyVfxEffectArgs(new Sequential_1.SequentialVfxStepArgs(vfx));
let ApplyVfxEffectHandler = class ApplyVfxEffectHandler {
    apply(sequence, container, state) { }
    remove(sequence, container, state) { }
};
ApplyVfxEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.ApplyVfx)
], ApplyVfxEffectHandler);
exports.ApplyVfxEffectHandler = ApplyVfxEffectHandler;
